import { Container } from "react-bootstrap";

const AccountDeletion = () => {
  return (
    <>
      <section className="common-area">
        <Container>
          <div className="term-condition-area">
            <h4 className="title">ACCOUNT DELETION POLICY</h4>
            <p>
              <b>
                PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING THE
                SERVICES.
              </b>
            </p>
            <p>
              Document Control
              <br></br> Updated on December 23, 2024 ‍<br></br> Version 1.0
            </p>
            {/* terms and conditions table view */}
            
            {/* terms and conditions table view */}
            <h6 className="sub-to-sub-title">1. Overview</h6>
            <p>
              This Account Deletion Policy outlines the procedures and
              guidelines for users who wish to delete their accounts on the
              Union App platform.
            </p>
            <h6 className="sub-to-sub-title">
              2. Account Rectification/Deletion Request
            </h6>
            <p>
              Users can request the rectification or deletion of their accounts
              by submitting a formal request through email or phone as specified
              in the Privacy Policy on the Website and App. The request should
              include the user's full name, username, and any other information
              necessary to identify the account.
            </p>
            <h6 className="sub-to-sub-title">3. Verification</h6>
            <p>
              To ensure the security and privacy of our users, the Union will
              verify the identity of the account owner before processing the
              deletion request. This may involve confirming account details,
              requesting additional information, or using multi-factor
              authentication.
            </p>
            <h6 className="sub-to-sub-title">4. Processing Time</h6>
            <p>
              Account deletion requests will be processed within 7 business days
              after successful verification and any other timelines as
              stipulated in the Data Protection and Privacy Act, 2019. During
              this period, users may not be able to access their accounts.
            </p>
            <h6 className="sub-to-sub-title">5. Data Retention</h6>
            <p>
              Once an account is rectified or deleted, all associated personal
              information and data will be permanently removed from our system.
              However, certain information may be retained for legal,
              accounting, or compliance purposes in accordance with applicable
              laws and regulations of our Data Retention Policy.
            </p>
            <h6 className="sub-to-sub-title">6. Communication</h6>
            <p>
              Users will be notified via support@unionmobilityapp.com once their
              account deletion/rectification request has been successfully
              processed. This communication will confirm the
              deletion/rectification and provide any additional information
              regarding the process.
            </p>
            <h6 className="sub-to-sub-title">7. Exceptions
            </h6>
            <p>
            In some cases, Union App may be legally or operationally obligated to retain certain user data even after an account is deleted. Users will be informed of such exceptions as applicable under the Data Privacy laws.

            </p>
            <h6 className="sub-to-sub-title">8. ‍Recovery Options
            </h6>
            <p>
            After an account is deleted, users may need to create a new account if they wish to use Union App services in the future. Deleted accounts cannot be recovered, and all associated data will be irreversibly erased.

            </p>
            <h6 className="sub-to-sub-title">9. ‍Contact Information
            </h6>
            <p>
            For account deletion/rectification requests and related inquiries, users can contact the Boda Union via <a href="mailto:support@unionmobilityapp.com">support@unionmobilityapp.com</a> or through the Data Protection Officer’s contacts as provided on the privacy policy from time to time.

            </p>
            <h6 className="sub-to-sub-title">10. Changes to the Policy

            </h6>
            <p>
            KaCyber Security Technologies Limited reserves the right to update or modify this Account Deletion Policy at any time. Users will be notified of any changes through the official company communication channels.

            </p>
            <p>By using Union App Services, users agree to adhere to the terms outlined in this Account Deletion Policy.
            </p>
          </div>
        </Container>
      </section>
    </>
  );
};
export default AccountDeletion;
